import { WindowSizeController } from '@adornis/chemistry/controllers/window-size-controller.js';
import { XTooltip } from '@adornis/popover/x-tooltip.js';
import { customElement, property, state } from 'lit/decorators.js';
import { takeUntil } from 'rxjs';

/**
 * @customElement cr-tooltip
 */
@customElement('cr-tooltip')
export class ChromiumTooltip extends XTooltip {
  @state() private readonly _size = new WindowSizeController(this);
  @property({ attribute: true, type: Boolean }) public clickable = false;

  constructor() {
    super();
    this.options.delay = 0;
    this.options.trigger = this.clickable ? 'click' : 'mouseenter focus';
  }

  override connectedCallback(): void {
    super.connectedCallback();

    this._size.observable.pipe(takeUntil(this.disconnected)).subscribe(size => {
      if (size.tablet) {
        this.options.trigger = 'click';
      } else {
        this.options.trigger = this.clickable ? 'click' : 'mouseenter focus';
      }

      this.reinit();
    });
  }
}
